/*
 * @Author: Gang Jiang 
 * @Date: 2024-09-14 15:26:35 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-11-26 11:18:14
 */
import client from './client';

export default {
  getList: (data) => {
    return client.get('editor/list?' + Object.keys(data).map(key => {
      return `${key}=${data[key]}`
    }).join('&')).then(res => res.data);
  },
  getSuggestionList: (type, data) => {
    return client.get('user/list/by-' + type + '?' + Object.keys(data).map(key => {
      return `${key}=${data[key]}`
    }).join('&')).then(res => res.data);
  },
  add: data => {
    return client.post('editor', data).then(res => res.data);
  },
  changeState: data => {
    return client.put('editor/' + data.id, data).then(res => res.data);
  },
  deleteInfluencer: id => {
    return client.delete('user/' + id, null).then(res => res.data);
  }
}